/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ counts: NonNullable<unknown> }} Report_Basis_Seats_PlainInputs */



/**
* | output |
* | --- |
* | "{counts} seats across the period" |
*
* @param {Report_Basis_Seats_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_basis_seats_plain = /** @type {((inputs: Report_Basis_Seats_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Basis_Seats_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.counts} Plätze im Zeitraum`)
	return /** @type {LocalizedString} */ (`${i?.counts} seats across the period`)
});